module.exports = __webpack_public_path__ + "static/media/sign-in-background.1f459e4c.png";